import React from "react";
import {
  Outside,
  Label,
  Input,
  LabelSpan
} from "../styled_components/styled_checkboxes/index";
import moment from "moment";
import t from '../../../helpers/t';

const CheckBoxes = ({ checked, setChecked, date, active }) => {
  return (
    <div className="ot-check-boxes">
      <Outside>
          {t('outside_hours')}
      </Outside>
      <Label>
        {t('check_in_on_request')}
        <Input
          type="checkbox"
          checked={checked.checkIn}
          onChange={()=>{}}
          disabled={
            moment(new Date(date)).isBefore(moment()) && !active
          }
        />
        {/** @todo React debug warning: Failed prop type: You provided a `checked` prop to a form field without an `onChange` handler.
          *  This will render a read-only field. If the field should be mutable use `defaultChecked`. 
          *  Otherwise, set either `onChange` or `readOnly`.
          */}
        <LabelSpan
            onClick={() => setChecked({ ...checked, checkIn: !checked.checkIn })}
            id="check_in"
            checked={checked.checkIn}
        />
      </Label>
      <Label>
          {t('check_out_on_request')}
        <Input
          type="checkbox"
          checked={checked.checkOut}
          onChange={() => {}}
          disabled={
            moment(new Date(date)).isBefore(moment()) && !active
          }
        />
        <LabelSpan
            id="check_out"
            onClick={() => setChecked({ ...checked, checkOut: !checked.checkOut })}
            checked={checked.checkOut}
        />
      </Label>
    </div>
  );
};

export default CheckBoxes;
